module.exports = __webpack_public_path__ + "img/master_card.d5694382.png";